module.exports = __webpack_public_path__ + "img/full4-min.f8c8e265.png";